import { createStore, useStore as baseUseStore, Store } from "vuex";
import { App, InjectionKey } from "vue";
import { IStore } from "./types";
import modules from "@/store/modules";

export const key: InjectionKey<Store<IStore>> = Symbol();

const plugins: any = [];

const store = createStore<IStore>({
  plugins,
  modules
});

export function useStore() {
  return baseUseStore(key);
}

export function setupStore(app: App) {
  app.use(store, key);
}

export default store;
